import { useEffect, useState } from "react";
import { Trash2, ChevronDown, ChevronUp, Mail, Phone } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { PageHeader } from "./AdminFaq";

function formatDate(s) { try { return new Date(s).toLocaleString("pt-PT"); } catch { return s; } }

export default function AdminContacts() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState({});

    async function load() {
        setLoading(true);
        try { const { data } = await api.get("/admin/contacts"); setItems(data || []); }
        catch (err) { toast.error(formatApiError(err?.response?.data?.detail) || "Erro"); }
        finally { setLoading(false); }
    }
    useEffect(() => { load(); }, []);

    async function onDelete(it) {
        if (!window.confirm(`Apagar mensagem de ${it.name}?`)) return;
        try { await api.delete(`/admin/contacts/${it.id}`); toast.success("Apagado"); load(); }
        catch (err) { toast.error(formatApiError(err?.response?.data?.detail) || "Erro"); }
    }

    return (
        <div data-testid="admin-contacts-page">
            <PageHeader title="Mensagens recebidas" subtitle="Submissões do formulário /contacto" count={items.length} />

            <div className="mt-8 space-y-3">
                {loading ? (
                    <div className="p-12 text-center text-muted-foreground rounded-2xl border border-border bg-white">A carregar...</div>
                ) : items.length === 0 ? (
                    <div className="p-12 text-center text-muted-foreground rounded-2xl border border-border bg-white">Sem mensagens ainda.</div>
                ) : (
                    items.map((it) => {
                        const open = !!expanded[it.id];
                        return (
                            <div key={it.id} data-testid={`contact-row-${it.id}`} className="rounded-2xl border border-border bg-white overflow-hidden">
                                <button onClick={() => setExpanded((p) => ({ ...p, [it.id]: !open }))}
                                    className="w-full px-5 py-4 flex items-center justify-between gap-4 text-left hover:bg-muted/30">
                                    <div className="min-w-0 flex-1">
                                        <div className="flex items-center gap-3 flex-wrap">
                                            <span className="font-heading font-bold text-primary">{it.name}</span>
                                            <span className="text-xs text-muted-foreground">{formatDate(it.created_at)}</span>
                                        </div>
                                        <div className="mt-1 text-xs text-muted-foreground truncate">
                                            {it.subject ? <strong>{it.subject} · </strong> : null}{it.message.slice(0, 100)}{it.message.length > 100 ? "..." : ""}
                                        </div>
                                    </div>
                                    {open ? <ChevronUp className="h-4 w-4 flex-shrink-0" /> : <ChevronDown className="h-4 w-4 flex-shrink-0" />}
                                </button>
                                {open && (
                                    <div className="px-5 pb-5 border-t border-border space-y-3">
                                        <div className="flex flex-wrap gap-4 text-sm pt-4">
                                            <a href={`mailto:${it.email}`} className="inline-flex items-center gap-1.5 text-primary hover:underline"><Mail className="h-4 w-4" /> {it.email}</a>
                                            {it.phone && <a href={`tel:${it.phone}`} className="inline-flex items-center gap-1.5 text-primary hover:underline"><Phone className="h-4 w-4" /> {it.phone}</a>}
                                            {it.subject && <span className="text-xs uppercase tracking-wider font-bold rounded-full bg-muted px-3 py-1">{it.subject}</span>}
                                        </div>
                                        <div className="text-sm whitespace-pre-wrap text-muted-foreground bg-muted/30 rounded-lg p-4">{it.message}</div>
                                        <div className="flex justify-end gap-2">
                                            <a href={`mailto:${it.email}?subject=Re: ${encodeURIComponent(it.subject || "O seu pedido")}`}
                                                className="inline-flex items-center gap-2 rounded-md bg-primary text-primary-foreground px-4 py-2 text-xs font-bold"><Mail className="h-3.5 w-3.5" /> Responder</a>
                                            <button onClick={() => onDelete(it)} className="inline-flex items-center gap-2 rounded-md bg-red-50 text-red-700 px-4 py-2 text-xs font-bold hover:bg-red-100"><Trash2 className="h-3.5 w-3.5" /> Apagar</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}
